import { booleanAttribute, Component, HostBinding, input } from '@angular/core';
import { InputBase } from '../base/input-base';

@Component({
  selector: 'app-input-text',
  styleUrl: './input-text.component.scss',
  templateUrl: './input-text.component.html',
  host: {
    class: 'grid grid-cols-12 col-span-12',
  },
})
export class InputTextComponent extends InputBase {
  helperText = input<string>();
  type = input<string>('');
  label = input<string>();
  placeholder = input<string>('');
  fullWidth = input(false, { transform: booleanAttribute });
  required = input(false, { transform: booleanAttribute });

  onInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.onChange(value);
    this.value = value;
  }

  @HostBinding('class')
  get hostClass() {
    let hostClassName = '';

    if (this.fullWidth()) {
      hostClassName += 'full-width ';
    }

    return hostClassName;
  }

  writeValue(value: unknown): void {
    this.value = value?.toString() ?? '';
  }
}
